type Size = "sm" | "md";

type Props = {
  value: string;
  label: string;
  size?: Size;
  onRemove?: () => void;
};

type Palette = { bg: string; border: string; text: string };

const PALETTES: Record<string, Palette> = {
  important: {
    bg: "hsl(0,85%,96%)",
    border: "hsl(0,80%,85%)",
    text: "hsl(0,75%,40%)",
  },
  follow_up: {
    bg: "hsl(40,95%,94%)",
    border: "hsl(40,85%,80%)",
    text: "hsl(35,85%,38%)",
  },
  technical: {
    bg: "hsl(210,85%,95%)",
    border: "hsl(210,75%,82%)",
    text: "hsl(210,85%,38%)",
  },
  reference: {
    bg: "hsl(270,70%,96%)",
    border: "hsl(270,60%,84%)",
    text: "hsl(270,60%,42%)",
  },
  decision: {
    bg: "hsl(180,60%,93%)",
    border: "hsl(180,50%,76%)",
    text: "hsl(180,70%,28%)",
  },
  team: {
    bg: "hsl(142,55%,94%)",
    border: "hsl(142,45%,78%)",
    text: "hsl(142,65%,30%)",
  },
  meeting_notes: {
    bg: "hsl(210,85%,95%)",
    border: "hsl(210,75%,82%)",
    text: "hsl(210,85%,38%)",
  },
  personal: {
    bg: "hsl(215,15%,94%)",
    border: "hsl(215,12%,82%)",
    text: "hsl(215,20%,38%)",
  },
  archive: {
    bg: "hsl(215,15%,94%)",
    border: "hsl(215,12%,82%)",
    text: "hsl(215,20%,38%)",
  },
  action_required: {
    bg: "hsl(22,95%,94%)",
    border: "hsl(22,85%,80%)",
    text: "hsl(22,85%,40%)",
  },
  _default: {
    bg: "hsl(215,15%,94%)",
    border: "hsl(215,12%,82%)",
    text: "hsl(215,20%,38%)",
  },
};

export function getTagPalette(value: string): Palette {
  return PALETTES[value] ?? PALETTES._default;
}

export function TagBadge({ value, label, size = "sm", onRemove }: Props) {
  const p = getTagPalette(value);
  const padding = size === "sm" ? "2px 8px" : "3px 10px";
  const fontSize = size === "sm" ? 11 : 12;
  return (
    <span
      className="inline-flex items-center gap-1 font-medium"
      style={{
        padding,
        borderRadius: 99,
        fontSize,
        background: p.bg,
        color: p.text,
        border: `1px solid ${p.border}`,
        lineHeight: 1.2,
      }}
    >
      {label}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-0.5 inline-flex h-3 w-3 items-center justify-center rounded-full hover:bg-black/10"
          style={{ color: p.text }}
          aria-label={`Remove ${label}`}
        >
          ×
        </button>
      )}
    </span>
  );
}
